import { AppService } from '@/services/app/AppService';

export default {
  install(Vue) {
    Vue.prototype.$app = new AppService()
  }
}